import { Link } from 'react-router-dom';
import useReveal from '../hooks/useReveal';

const WhyChooseUs = () => {
  useReveal();

  return (
    <>
      <section className="page-hero">
        <h1>Key Differentiators</h1>
      </section>

      <section className="trust-section">
        <div className="trust-container">
          <div className="trust-visual">
            <div className="decorative-blocks">
              {/* <div className="block"></div>
              <div className="block"></div>
              <div className="block"></div>
              <div className="block"></div> */}

            <img src="/images/choose_us/1.png" alt="Our Vision & Mission" style={{ width: "100%", height: "auto", borderRadius: "24px", boxShadow: "0 20px 40px rgba(0,0,0,0.1)" }} />

            </div>
          </div>
          <div className="trust-content fade-in">
            <h2>Trust &amp; Compliance Focus</h2>
            <ul className="feature-list">
              {/* <li>Only SEBI, RBI, And IRDAI-Regulated Products Recommended.</li> */}
              <li>No Risky Or Unverified Investment Schemes.</li>
              <li>Transparent Advisory Process.</li>
              <li>Ethical And Responsible Guidance.</li>
              <li>Your Trust Is Protected.</li>
            </ul>
          </div>
        </div>
      </section>

      <section className="client-centric">
        <div className="client-container">
          <div className="client-visual">
            <div className="decorative-blocks">
              {/* <div className="block"></div>
              <div className="block"></div>
              <div className="block"></div>
              <div className="block"></div>
              <div className="block"></div>
              <div className="block"></div> */}


            <img src="/images/choose_us/2.png" alt="Our Vision & Mission" style={{ width: "100%", height: "auto", borderRadius: "24px", boxShadow: "0 20px 40px rgba(0,0,0,0.1)" }} />



            </div>
          </div>
          <div className="client-content fade-in">
            <div className="section-label">Our Approach</div>
            <h2>Client-Centric Approach</h2>
            <ul className="feature-list">
              <li>Your Goals Drive The Financial Strategy.</li>
              <li>Plans Evolve With Income And Responsibilities.</li>
              <li>Long-Term Relationships Over Short-Term Sales.</li>
              <li>Personalised Financial Solutions.</li>
              <li>Every Family Is Unique.</li>
            </ul>
          </div>
        </div>
      </section>

      <section className="need-help-cta">
        <div className="cta-content">
          <h2>"Need Help?"</h2>
          <h3>Looking For The Best Financial Advisor In Puducherry?</h3>
          <p>One Review Can Uncover Hidden Risks. Start With Clarity, Not Assumptions.</p>
          <p>Secure Your Future With The Right Guidance.</p>
          <Link to="/contact" className="cta-button">Start Your Free EMI-to-Wealth Check</Link>
        </div>
      </section>
    </>
  );
};

export default WhyChooseUs;
